/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { useEffect, useState } from "react";
import { Redirect, Switch, Route, useHistory } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage, selectMe } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import { useIdleTimer } from "react-idle-timer";
import { env } from "../env";
import { releaseUser } from "./pages/user/userSlice";
import { showErrorDialog, username } from "./utility";
import jwt_decode from "jwt-decode";

export function Routes() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
    }),
    shallowEqual
  );

  const { token } = useSelector(
    ({ auth }) => ({
      token: auth.token,
    }),
    shallowEqual
  );

  const time = `${env.REACT_APP_TIME}`;

  const [state, setState] = useState("Active");
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") {
      const interval = setInterval(() => {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }, 500);
      return () => {
        clearInterval(interval);
      };
    }
  });

  const onIdle = async () => {
    if (isAuthorized === true) {
      await handleLogout();
      // localStorage.clear();
      // window.location.reload();
    }
  };

  const onActive = () => {
    setState("Active");
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    timeout: time,
    throttle: 500,
    crossTab: true,
  });

  const handleLogout = async (user) => {
    const decoded = jwt_decode(token);

    const username = decoded.id;
    const params = {
      username: username,
    };

    try {
      const response = await dispatch(releaseUser(params));
      if (response.payload.data.status === 200) {
        history.push("/logout");
      } else {
        // history.push("/logout");
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return (
    <Switch>
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        <Layout>
          <BasePage />
        </Layout>
      )}
    </Switch>
  );
}
